<template>
  <metainfo></metainfo>
  <div class="container-xl">
    <div class="page-header d-print-none">
      <div class="row g-2 align-items-center">
        <div class="col-sm">
          <h2 class="page-title">Статистика</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="page-body">
    <div class="container-xl">
      <Common/>
    </div>
  </div>
</template>

<script>
import {defineComponent} from "vue"
import {useMeta} from "vue-meta"
import Common from "./components/common/Common"

export default defineComponent({
  components: {
    Common,
  },
  name: "Statistic",
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  setup() {
    useMeta({title: "Статистика"})

    return {}
  },
})
</script>

<style scoped>

</style>
